// APN/parcel-number-looking search query detection (#1176).
//
// Mirrors the backend's `_APN_LIKE_RE` (backend/src/landai/api/v1/parcels.py):
// digits + dashes, 6+ chars, at least one digit, fullmatch. The backend uses
// this to add dash-normalized parcel_id limbs to the /parcels and
// /parcels/table q-search; the frontend uses it to
//   1. resolve an APN-like map search directly to a parcel and drive the
//      #708 FocusFlyer (zoom to the parcel boundary), and
//   2. skip the Nominatim place geocode, which can never resolve an APN
//      and would otherwise race the parcel focus with a bogus fly-to.
//
// The at-least-one-digit lookahead keeps an all-dash string ("------")
// from qualifying, matching the backend guard against ILIKE '%%'.
export const APN_LIKE_RE = /^(?=.*\d)[\d-]{6,}$/;

export function isApnLikeQuery(q) {
  return typeof q === 'string' && APN_LIKE_RE.test(q.trim());
}
